export default function EstimatedQuoteCardSkeleton() {
  return (
    <div className="w-full bg-white rounded-xl shadow-sm border border-gray-100 p-4 space-y-4 animate-pulse">
      {/* Header */}
      <div className="flex justify-between items-center pb-2 border-b border-gray-100">
        <div className="h-5 w-40 bg-gray-200 rounded"></div>
        <div className="h-6 w-16 bg-gray-200 rounded"></div>
      </div>

      {/* Route */}
      <div className="flex items-center bg-blue-50 p-3 rounded-lg">
        {/* From */}
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 bg-blue-200 rounded-full"></div>
          <div>
            <div className="h-3 w-10 bg-gray-200 rounded mb-1"></div>
            <div className="h-4 w-24 bg-gray-200 rounded"></div>
          </div>
        </div>

        {/* Arrow */}
        <div className="flex-1 flex justify-center text-blue-300 text-xl font-semibold">
          →
        </div>

        {/* To */}
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 bg-red-200 rounded-full"></div>
          <div>
            <div className="h-3 w-10 bg-gray-200 rounded mb-1"></div>
            <div className="h-4 w-24 bg-gray-200 rounded"></div>
          </div>
        </div>
      </div>

      {/* Details */}
      <div className="grid grid-cols-4 gap-4 text-sm">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="flex flex-col space-y-1">
            <div className="h-3 w-16 bg-gray-200 rounded"></div>
            <div className="h-4 w-20 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>

      <div className="border-t border-gray-100 pt-2">
        <div className="flex justify-between items-center">
          <div className="h-4 w-28 bg-gray-200 rounded"></div>
          <div className="w-5 h-5 bg-gray-200 rounded-full"></div>
        </div>
      </div>
    </div>
  );
}
